import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchContent } from "../lib/api";
import { DEFAULTS } from "../data/site";

const ContentContext = createContext({ content: DEFAULTS, loading: true, refresh: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchContent();
      setContent({ ...DEFAULTS, ...data });
    } catch {
      setContent(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
export const useSite = () => useContext(ContentContext).content;
